export default function RefreshIcon(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path d="M9 12l-4.463 4.969L0 12h3a9 9 0 019-9c2.395 0 4.565.942 6.179 2.468l-2.004 2.231A5.975 5.975 0 0012 6c-3.309 0-6 2.691-6 6h3zm10.463-4.969L15 12h3c0 3.309-2.691 6-6 6a5.978 5.978 0 01-4.175-1.699l-2.004 2.231A8.961 8.961 0 0012 21a9 9 0 009-9h3l-4.537-4.969z" />
    </svg>
  )
}
